<template>
  <div>
    <vs-button
      color="#32C040"
      icon="add_box"
      class="ml-2"
      style="border-radius: 20px"
      v-b-modal.AddStock
    >
      Add Stock
    </vs-button>
    <b-modal id="AddStock" centered size="lg">
      <template #modal-title>
        <h3>Add Stock</h3>
      </template>
      <div v-for="(stock, index) in stocks" :key="index">
        <vs-row class="ml-5">
          <vs-select
            :color="success"
            class="selectExample"
            placeholder="Please Select Part"
            label="Part Name"
            v-model="stock.id"
            :danger="stockdanger"
            danger-text="Please Selct Part"
            @change="selectpart(stock), stockvalidate(stock.id)"
            ><br />
            <vs-select-item
              :key="index"
              :value="item.id"
              :text="item.name"
              v-for="(item, index) in desserts"
            />
          </vs-select>
          <div class="ml-4 mt-4">
            <vs-input-number
              color="success"
              v-model="stock.qtycurrent"
              min="0"
              label="current:"
              disabled
            />
          </div>
          <div class="ml-4 mt-4">
            <vs-input-number
              color="success"
              v-model="stock.restock"
              label="restock:"
              min="0"
            />
          </div>
          <div class="ml-1 mt-4">
            <vs-button
              color="#FC3939"
              icon="delete"
              type="flat"
              class="ml-2"
              style="border-radius: 20px"
              @click="deletestcok(index)"
            >
            </vs-button>
          </div>
        </vs-row>
      </div>

      <br />
      <div>
        <vs-button
          color="#32C040"
          icon="add_box"
          class="ml-5"
          style="border-radius: 20px"
          @click="addStocks()"
        >
          add another parts
        </vs-button>
      </div>
      <template #modal-footer>
        <vs-row>
          <vs-spacer />

          <b-button
            id="btncancel"
            variant="light"
            style="border-radius: 20px; width: 10%"
            @click="$bvModal.hide('AddStock')"
          >
            Cancle
          </b-button>
          <vs-button
            type="filled"
            style="border-radius: 20px; width: 10%"
            class="ml-2"
            @click="savestock()"
            >Submit</vs-button
          >
        </vs-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    desserts: Array,
    location: Array,
  },
  created() {},
  data() {
    return {
      stockdanger: false,
      stocks: [
        {
          id: 0,
          qtycurrent: 0,
          restock: 0,
          name: "",
          category: "",
          location: 0,
          open_pos: "",
          part_name: "",
          part_number: 0,
          price: 0,
          vendor: "",
        },
      ],
    };
  },
  methods: {
    selectpart(stock) {
      const res = this.desserts.filter((data) => data.id == stock.id);
      stock.qtycurrent = res[0].qtycurrent;
      stock.name = res[0].name;
      stock.category = res[0].category;
      stock.location = res[0].location;
      stock.open_pos = res[0].openpos;
      stock.part_name = res[0].name;
      stock.part_number = res[0].partnumber;
      stock.price = res[0].price;
      stock.vendor = res[0].vendor;
    },
    addStocks() {
      this.stocks.push({
        id: 0,
        qtycurrent: 0,
        restock: 0,
      });
    },
    deletestcok(index) {
      this.stocks.splice(index, 1);
    },

    savestock() {
      const data = this.stocks;
      const data2 = this.location;
      console.log(data[0].id, "log");
      if (data[0].id == 0) {
        this.stockdanger = true;
      } else {
        this.stockdanger = false;
      }
      data.forEach((arraydata) => {
        console.log(arraydata.location, "id");
        const locat_id = data2.filter(
          (loc) => arraydata.location == loc.location_name
        );
        console.log(locat_id, "id2");
        const loc_id = locat_id[0].id;
        let data3 = {
          id: parseInt(arraydata.id),
          qty: parseInt(arraydata.qtycurrent),
          qty_new: parseInt(arraydata.restock),
          total: parseInt(arraydata.qtycurrent) + parseInt(arraydata.restock),
          name: arraydata.name,
          category: arraydata.category,
          location_id: loc_id,
          open_pos: arraydata.open_pos,
          part_name: arraydata.name,
          part_number: arraydata.part_number,
          price: arraydata.price,
          vendor: arraydata.vendor,
          asset: arraydata.asset,
        };
        console.log(data3, "data3");
        this.$API.put("parts/update", data3).then((res) => {
          const data3 = res.data;
        });
        setTimeout(() => {
          location.reload();
        }, 500);
      });
    },
    stockvalidate(data) {
      if (data == 0) {
        this.stockdanger = true;
      } else {
        this.stockdanger = false;
      }
    },
  },
};
</script>

<style>
</style>